import { useState, useEffect } from "react";
import apiClient from "../../../shared/API/apiClient";

const LocationMappingModal = ({ data, onClose, onSave }) => {
  const [sites, setSites] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [loadingSites, setLoadingSites] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // // ── Pre-select already mapped locations ───────────────────


  useEffect(() => {
  if (Array.isArray(data?.location_ids)) {
    const ids = data.location_ids.map((loc) => loc.id);

    setSelectedSites(ids);
  } else {
    setSelectedSites([]);
  }
}, [data]);

  // ── Fetch available sites ─────────────────────────────────
  useEffect(() => {
    const fetchSites = async () => {
      try {
        setLoadingSites(true);
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const org_id = user?.org_id;
        if (!org_id) return;

        const res = await apiClient.get(`/api/sites-locations?org_id=${org_id}`);
        setSites(res.data?.data || []);
      } catch (err) {
        console.error("Sites fetch error:", err);
        setError("Failed to load locations.");
      } finally {
        setLoadingSites(false);
      }
    };

    fetchSites();
  }, []);

  // ── Checkbox toggle ───────────────────────────────────────
  const handleCheckbox = (site_id) => {
    setSelectedSites((prev) =>
      prev.includes(site_id)
        ? prev.filter((id) => id !== site_id)
        : [...prev, site_id]
    );
  };

  // ── Select / Deselect all ─────────────────────────────────
  const allSelected =
    sites.length > 0 && sites.every((s) => selectedSites.includes(s.site_id));

  const handleToggleAll = () => {
    if (allSelected) {
      setSelectedSites([]);
    } else {
      setSelectedSites(sites.map((s) => s.site_id));
    }
  };

  // ── Submit ────────────────────────────────────────────────
  const handleSubmit = async () => {
    try {
      setSaving(true);
      setError(null);

      const res = await apiClient.post("/api/year-location-mapping", {
        year_label: data.year_label,
        location_ids: selectedSites,   // array of numbers
      });

      if (!(res.data?.code === 200 || res.data?.success)) {
        throw new Error(res.data?.message || "Mapping failed");
      }

      onSave(res.data?.message || "Locations mapped successfully");
    } catch (err) {
      console.error("Mapping error:", err);
      setError(
        err.response?.data?.message || err.message || "Something went wrong"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-box"
        style={{ maxWidth: "520px" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="modal-header">
          <div>
            <div className="modal-title">Map Locations</div>
            <div className="modal-subtitle" style={{ fontSize: "13px", color: "#888", marginTop: "2px" }}>
           {data?.year_label}
                &nbsp;&nbsp;
                <span>
                <strong>
                    [
                    Start Date:{" "}</strong>
                    {data?.start_date
                    ? new Date(data.start_date).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        })
                    : "—"}
                    {"  "} 
                    <strong>  End Date:{" "}</strong>
                    {data?.end_date
                    ? new Date(data.end_date).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        })
                    : "—"}
                 <strong>   
                    ]
                </strong>
                </span>
            </div>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {/* Year info strip */}
          <div>
          
          </div>

          {/* Locations */}
          <div className="org-form-field">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <label className="org-field-label" style={{ margin: 0 }}>
                Select Locations
              </label>
              {sites.length > 0 && (
                <span
                  style={{
                    fontSize: "12px",
                    color: "var(--primary, #2563eb)",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                  onClick={handleToggleAll}
                >
                  {allSelected ? "Deselect All" : "Select All"}
                </span>
              )}
            </div>

            {loadingSites ? (
              <p className="empty-text">Loading locations...</p>
            ) : sites.length === 0 ? (
              <p className="empty-text">No locations available.</p>
            ) : (
              <div className="location-list">
                {sites.map((site) => (
                  <label key={site.site_id} className="location-row">
                    <input
                      type="checkbox"
                      className="location-checkbox"
                      checked={selectedSites.includes(site.site_id)}
                      onChange={() => handleCheckbox(site.site_id)}
                    />
                    <span className="location-text">{site.site_name}</span>
                  </label>
                ))}
              </div>
            )}

            {/* Selected count */}
            {selectedSites.length > 0 && (
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  color: "#666",
                }}
              >
                {selectedSites.length} location
                {selectedSites.length !== 1 ? "s" : ""} selected
              </div>
            )}
          </div>

          {/* Error */}
          {error && (
            <div
              style={{
                marginTop: "12px",
                color: "var(--error, #dc2626)",
                fontSize: "13px",
              }}
            >
              {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button
            className="org-btn-cancel"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            className="org-btn-save"
            onClick={handleSubmit}
            disabled={saving || loadingSites}
          >
            {saving ? "Saving..." : "Save Mapping"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationMappingModal;
